import { useState } from 'react';
import { Navbar, AppTab } from './components/layout/Navbar';
import { CardGame } from './components/game/CardGame';
import { EquationLab } from './components/lab/EquationLab';
import { EquationLibrary } from './components/library/EquationLibrary';
import { Sparkles, Globe } from 'lucide-react';

export function App() {
  const [activeTab, setActiveTab] = useState<AppTab>('trainer');

  return (
    <div className="min-h-screen flex flex-col bg-slate-950 text-slate-100 selection:bg-teal-500 selection:text-slate-950">
      {/* Navigation Header */}
      <Navbar activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Main App Content */}
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-8">
        {activeTab === 'trainer' && <CardGame />}
        {activeTab === 'lab' && <EquationLab />}
        {activeTab === 'curricula' && <EquationLibrary />}
      </main>

      {/* Footer */}
      <footer className="w-full border-t border-slate-900 py-6 bg-slate-950/60 mt-12 text-xs text-slate-500">
        <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-teal-400 animate-ping" />
            <span>Math Intuition Engine</span>
            <span>·</span>
            <span>Building geometric intuition for 2D & 3D functions</span>
          </div>

          <div className="flex items-center gap-4 font-mono text-[11px]">
            <a
              href="https://math.hyperfloatcloud.com"
              className="text-teal-400 hover:text-teal-300 transition flex items-center gap-1"
            >
              <Globe className="w-3.5 h-3.5" /> math.hyperfloatcloud.com
            </a>
            <span>·</span>
            <span className="flex items-center gap-1 text-slate-400">
              <Sparkles className="w-3 h-3 text-amber-400" /> Cloudflare Pages
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
